import React, { Fragment } from 'react'
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'

const Textarea = ({
  className = '',
  onValueChange,
  name,
  errors = {},
  placeholder = '',
  rules = {},
  control,
  label = '',
  value,
  required = false,
  disabled = false,
  maxLength
}) => {
  return (
    <Fragment>
      {label && (
        <label className="grc-label block mb-1">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange } }) => (
          <textarea
            disabled={disabled}
            className={`input-grc flex h-24 w-full rounded-lg border border-input bg-transparent !mt-2 px-3 py-3 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
            placeholder={placeholder}
            onChange={(e) => {
              onChange(e.target.value) // Updates react-hook-form state
              if (onValueChange) onValueChange(e.target.value, name) // Calls the custom onValueChange if provided
            }}
            value={value || ''} // Controlled value from react-hook-form
            maxLength={maxLength} // Maximum allowed characters for input
          />
        )}
      />

      {errors[name] && (
        <p className="grc-error-msg text-danger">{errors[name].message}</p>
      )}
    </Fragment>
  )
}

Textarea.propTypes = {
  className: PropTypes.string,
  onValueChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.object,
  rules: PropTypes.object,
  control: PropTypes.object.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool
}

export default Textarea
